import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SERVER_TIMEZONE } from '../constants';
dayjs.extend(utc);
dayjs.extend(timezone);
var getConfirmationMessage = function (_a) {
    var deliveryDate = _a.deliveryDate;
    var isImmediate = deliveryDate.isSame(dayjs().tz(SERVER_TIMEZONE), 'day');
    if (isImmediate) {
        return 'You completed a transfer.';
    }
    return 'You scheduled a transfer.';
};
export default getConfirmationMessage;
//# sourceMappingURL=getConfirmationMessage.js.map